import Reveal from "@/components/Reveal";

const HomeChef = ({ content }) => {
  const imgUrl = content?.image_url || "https://images.unsplash.com/photo-1577219491135-ce391730fb2c?auto=format&fit=crop&q=80";

  return (
    <section className="py-24 md:py-36 bg-transparent overflow-hidden border-t border-sm-border/50">
      <div className="sm-container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-8 items-center">

          {/* Images Left */}
          <div className="relative h-[500px] lg:h-[700px] w-full order-2 lg:order-1 mt-10 lg:mt-0">
            <Reveal className="absolute top-[10%] left-0 w-[85%] h-[80%] z-10 shadow-2xl">
              <img
                src={imgUrl}
                alt="Arditi"
                className="w-full h-full object-cover grayscale-[15%] object-[center_20%]"
              />
            </Reveal>
            <Reveal delay={0.2} className="absolute bottom-0 right-[5%] w-px h-32 bg-sm-gold z-20 hidden md:block" />
          </div>

          {/* Text Right */}
          <div className="relative pr-8 md:pr-12 lg:pl-16 order-1 lg:order-2 z-10 text-left lg:text-right flex flex-col items-start lg:items-end">
            <div className="absolute right-0 top-0 bottom-0 w-px bg-sm-gold hidden lg:block" />
            <div className="absolute left-0 top-0 bottom-0 w-px bg-sm-gold block lg:hidden" />
            <div className="lg:pr-8 pl-8 lg:pl-0">
              <Reveal>
                <p className="sm-eyebrow mb-6">{content?.eyebrow}</p>
                <h2 className="font-serif text-4xl md:text-5xl text-sm-text font-light leading-tight mb-8">
                  {content?.title_line_1} <br className="hidden lg:block" />
                  <span className="italic">{content?.title_line_2}</span>
                </h2>
              </Reveal>
              <Reveal delay={0.1}>
                <p className="text-base text-sm-muted font-light leading-relaxed mb-6">
                  {content?.bio_1}
                </p>
                <p className="text-base text-sm-muted font-light leading-relaxed mb-10">
                  {content?.bio_2}
                </p>
              </Reveal>
              <Reveal delay={0.2}>
                <a href="/chef" className="inline-block border-b border-sm-gold text-[0.7rem] tracking-[0.25em] uppercase pb-1 hover:text-sm-gold transition-colors">
                  Zbulo më shumë
                </a>
              </Reveal>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default HomeChef;
